import { useMemo } from 'react'

import { useExpandedRows } from '../../../../../contexts/expandedRowsContext'
import { TableRow } from '../../../../../elements/TableRow'
import { mapTrialBalanceBalances } from '../../../../../utils/balanceMappers'
import { buildTableData } from '../../../../../utils/buildTableData'
import { useTrialBalanceFilters } from '../../contexts/trialBalanceFiltersContext'
import { TrialBalanceInputRowComponent } from '../../types/inputTypes'
import { BalanceCells } from '../BalanceCells'

interface TrialBalanceTableBodyProps {
  reportData: TrialBalanceInputRowComponent[]
}

export const TrialBalanceTableBody = ({ reportData }: TrialBalanceTableBodyProps) => {
  const { expandedRows } = useExpandedRows()
  const { appliedFilters } = useTrialBalanceFilters()

  const tableData = useMemo(
    () => buildTableData(reportData, expandedRows, [], mapTrialBalanceBalances),
    [expandedRows, reportData],
  )
  const periodQuery = useMemo(() => appliedFilters.period, [appliedFilters.period])

  return (
    <tbody>
      {tableData.map((row) => (
        <TableRow row={row} key={row.id}>
          <BalanceCells row={row} periodQuery={periodQuery} />
        </TableRow>
      ))}
    </tbody>
  )
}
